































import { defineComponent, ref } from "@nuxtjs/composition-api";
import { PropType } from "vue";
import { BundleProduct } from "~/composables";
import { SfIcon } from "@storefront-ui/vue";
import Price from "~/components/Price.vue";
import AddToCart from "~/components/AddToCart.vue";
import { merge } from "lodash-es";
export default defineComponent({
  components: {
    SfIcon,
    Price,
    AddToCart,
  },
  props: {
    product: {
      type: Object as PropType<BundleProduct>,
      required: true,
    },
  },
  setup(props) {
    const bundleProduct = ref<BundleProduct>(props.product);
    /**
     * Creating bundle product object required for add to cart action.
     */
    bundleProduct.value = merge({}, props.product, {
      bundle_options: [{
        id: props.product.items[0].option_id,
        value: props.product.items[0].options.map((el) => el.id)
      }]
    });
    const modulesSkus = ref<String[]>(props.product.items[0].options.map(opt=>opt.product.sku));
  
    return {
      bundleProduct,
      modulesSkus
    };
  },
});
